import axios from "axios";
import { API } from "./api";

// Separate token store from the admin/client auth system (phm_token) so an admin
// testing the member portal in the same browser doesn't clash with their own session.
export const MEMBER_TOKEN_KEY = "phm_member_token";

export const memberTokenStore = {
  get: () => sessionStorage.getItem(MEMBER_TOKEN_KEY),
  set: (t) => sessionStorage.setItem(MEMBER_TOKEN_KEY, t),
  clear: () => sessionStorage.removeItem(MEMBER_TOKEN_KEY),
};

export const memberApi = axios.create({ baseURL: API, withCredentials: false });

memberApi.interceptors.request.use((config) => {
  const token = memberTokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
